import { render, staticRenderFns } from "./DetailedPayment.vue?vue&type=template&id=fcca8a28"
import script from "./DetailedPayment.vue?vue&type=script&lang=js"
export * from "./DetailedPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports